// Externals
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { getDynamicUrl } from '../../middleware/lokaliseUrlMiddleware';

// Contants
import { withCurrency } from '../currency';

// Selectors
import { selectSession } from '../../selectors/session';

// Components
import { Footer as FooterPageComponent } from '@homeexchange/footer';

import i18n from '../../i18n';

const Footer = (props) => {
    const { currency, session } = props;

    const isHomepage = document.getElementById('home-page') !== null;
    const isDashboard = document.getElementById('dashboard') !== null;
    const isCmsPage = document.getElementById('cms-page') !== null;
    const appearance = (isHomepage || isDashboard) && !isCmsPage ? 'dark' : 'light';

    return (
        <FooterPageComponent
            apiUrl={getDynamicUrl(process.env.URL_BFF)}
            assetsUrl={process.env.URL_MIGRATION_ASSETS}
            locale={i18n.language}
            session={session}
            currency={currency}
            appearance={appearance}
        />
    );
};

Footer.propTypes = {
    session: PropTypes.object,
    currency: PropTypes.string
};

const mapStateToProps = (state) => ({
    session: selectSession(state),
    currency: state.currency
});

const mapDispatchToProps = (dispatch) => ({
    redirectToSearch: bindActionCreators(dispatch)
});

export default compose(connect(mapStateToProps, mapDispatchToProps), withCurrency)(Footer);
